'use strict';

angular.module('atex.dam').factory('DamVersionService', [ '$q', '$rootScope', function($q, $rootScope) {
  var serviceHandler = atex.VersionServiceHandler(atex.onecms.AngularUtils.applyingQ($q, $rootScope)), cachedVersion;
  
  return {
    getVersion : function() {
      if (!cachedVersion) {
        cachedVersion = serviceHandler.getVersion();
      }

      return cachedVersion;
    }
  };
} ]);
